import { request } from '@/service/request';

export interface LoginFormVo {
  account: string;
  captchaVO: string;
  email: string;
  pwd: string;
}
export interface LoginCodeVo {
  account: string;
  email: string;
}
export interface UpdatePasswordVo {
  code: string;
  confirmPassword: string;
  oldPassword: string;
  password: string;
}

export function login(data: LoginFormVo) {
  return request({
    data,
    method: 'post',
    url: '/platform/login'
  });
}
export function getLoginCode(data: LoginCodeVo) {
  return request({
    data,
    method: 'post',
    url: '/platform/login/getLoginCode'
  });
}
export function sendUpdatePasswordEmailCode() {
  return request({
    method: 'post',
    url: '/platform/login/admin/sendUpdatePasswordEmailCode'
  });
}
// 修改登录用户密码(V1.1.0)
export function updatePassword(data: UpdatePasswordVo) {
  return request({
    data,
    method: 'post',
    url: '/platform/login/admin/update/password'
  });
}
